import { Field } from "@sitecore-jss/sitecore-jss-react";
import React, { useReducer } from "react";
import { useHistory } from "react-router-dom";

import { fetchDcpPolicy } from "../../../api/policy";
import { Button } from "../../../components/buttons/Button";
import { Divider } from "../../../components/dividers/Divider";
import { SearchLoader } from "../../../components/loaders/searchLoader/SearchLoader";
import { POLICY_NR_QUERY_PARAM } from "../../policyDetails/PolicyDetails";
import { SearchByPolicyNumberFields } from "../searchByPolicyNumberFields/SearchByPolicyNumberFields";
import styles from "./SearchDcpPolicy.module.scss";
import { initialState, searchDcpPolicyReducer } from "./SearchDcpPolicy.state";

interface Props {
  fields: Record<string, Field<string & { href: string }>>;
}

export const SearchDcpPolicy = ({ fields }: Props) => {
  const history = useHistory();
  const [{ loading, message, policyNumber }, dispatch] = useReducer(searchDcpPolicyReducer, initialState);

  const handleUpdatePolicyNumber = (data: { policyNumber?: string }) => {
    dispatch({ type: "UPDATE_POLICY_NUMBER", payload: { policyNumber: data.policyNumber } });
  };

  const retrieveDcpPolicy = async () => {
    if (!policyNumber) {
      return;
    }

    dispatch({ type: "FETCH_DATA" });

    try {
      await fetchDcpPolicy(policyNumber);

      history.push(`${fields.DetailPageLink.value.href}?${POLICY_NR_QUERY_PARAM}=${policyNumber}`);
    } catch {
      dispatch({
        type: "FETCH_ERROR",
        payload: { message: "De polis kan niet gevonden worden." },
      });
    }
  };

  return (
    <>
      <div className={styles.searchDcpPolicy__container}>
        <SearchByPolicyNumberFields
          fields={fields}
          handleUpdatePolicyNumber={handleUpdatePolicyNumber}
          values={{ policyNumber }}
        />
        <div className={styles.searchDcpPolicy__searchButton}>
          <Button loading={loading} leading={<i className="icon icon-search" />} onClick={retrieveDcpPolicy}>
            Openen
          </Button>
        </div>
      </div>
      <Divider type="horizontal" />
      <SearchLoader text={message ?? "Zoek op basis van polisnummer."} />
    </>
  );
};
